import {getLanguage} from '@smart/locale-service';
import {useFeatureAppEnv} from '@smart/react-utils';
import {useEffect, useState} from 'react';
import type {LeasingInformationModel} from '../../bff/leasing-information/leasing-information-model';
import {fetchLeasingInformationModel} from '../utils/fetch-leasing-information-model';
import {useLocale} from './use-locale';

export function useLeasingInformation(
  salesType: string,
): LeasingInformationModel | undefined {
  const [leasingInformationModel, setLeasingInformationModel] = useState<
    LeasingInformationModel | undefined
  >();
  const {baseUrl, featureServices} = useFeatureAppEnv();
  const {'endpoint-directory': endpointDirectory} = featureServices;
  const {marketId, languageTag} = useLocale();
  const language = getLanguage(languageTag);
  const [error, setError] = useState<unknown>();

  if (error) {
    throw error;
  }

  if (!endpointDirectory) {
    throw Error(`Endpoint directory is undefined.`);
  }

  useEffect(() => {
    const controller = new AbortController();
    const {signal} = controller;

    fetchLeasingInformationModel(
      baseUrl,
      {
        endpointDirectory,
        marketId,
        language,
        salesType,
      },
      signal,
    )
      .then((res) => {
        if (signal.aborted) return;
        setLeasingInformationModel(res);
      })
      .catch((err) => {
        if (signal.aborted) return;
        setError(err);
      });

    return () => controller.abort();
  }, [baseUrl, marketId, salesType, language, endpointDirectory]);

  return leasingInformationModel;
}
